import interview from './interview/'
import activity from './activity/'
import template from './template/'
import article from './article/'
import picture from './picture/'
import common from './common'
import login from './login'
import link from './link/'
import message from './message/'
import address from './address/'
import website from './website/'
import journal from './journal/'
import activitiesSet from './activitiesSet/'
export default {
  ...link,
  ...login,
  ...common,
  ...picture,
  ...article,
  ...template,
  ...activity,
  ...interview,
  ...message,
  ...address,
  ...website,
  ...journal,
  ...activitiesSet
}
